import { getQuery } from 'utilities/query';

export default class SystemIngredientsService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getDefaultQuery() {
    return {
      ...getQuery(),
      orderBy: 'SystemIngredientName',
      direction: 'asc'
    };
  }

  search(query) {
    return this.$http.get('/odata/SystemIngredientOData', {
      params: {
        $select: 'SystemIngredientId, SystemIngredientName, IUtoMgConversiontRate',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  delete(id) {
    return this.$http.delete(`/api/system_ingredient/${id}`);
  }

  add(ingredient) {
    return this.$http.post('/api/system_ingredient', ingredient);
  }

  update(ingredient) {
    return this.$http.put(`/api/system_ingredient/${ingredient.SystemIngredientId}`, ingredient);
  }

  isUniqueIngredientName(ingredientName, id) {
    return this.$http.get('/api/system_ingredient/unique_ingredient_name', {
      params: {
        SystemIngredientName: ingredientName,
        id
      }
    });
  }
}



// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredients.service.js